<template>
	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<el-table :data="positionList" border style="width: 100%">
			<el-table-column prop="lat" label="纬度">
			</el-table-column>
			<el-table-column prop="lng" label="经度">
			</el-table-column>
			<el-table-column prop="fenceStatus" label="围栏状态">
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes,prev, pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import mybread from "@/components/bread"
	export default {
		components: {
			mybread
		},
		inject: ['reload'],
		data() {
			return {
				positionList: [],
				total: 0, //总页数
				pageSize: 10, //每页条数
				currentPage: 1, //当前页（默认第一页）
				list_loading:true
			}
		},
		created() {
			this.getPositionList()
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val; //获取当前页
				this.getPositionList();
			},
			handleSizeChange(psize) { //选择每页条数
				this.pageSize = psize;
				this.getPositionList();
			},
			getPositionList() {
				const data = {
					length: this.pageSize,
					start: (this.currentPage - 1) * this.pageSize
				}
				this.$get("api/showLocationList", data).then(res => {
					this.positionList = res.data
					this.total = res.recordsFiltered
					this.list_loading=false
				}).catch((e) => {
					window.console.log(e)
				})
				
			},
		},
	}
</script>

<style scoped="scoped">
 .block {
		text-align: center;
		margin-top: 20px;
	}
	.main{
		background: #fff;
		padding:0 20px 20px 20px;
	}
</style>
